<template>
    <div class="account">
        <div class="container">
            <div class="account__wrapper">
                <AccountSideMenu></AccountSideMenu>

                <div class="account__contain">
                    <AccountProfile></AccountProfile>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import AccountSideMenu from "./AccountSideMenu.vue";
import AccountProfile from "./AccountProfile.vue";

export default {
    name: "Account",
    components: {
        AccountSideMenu,
        AccountProfile
    },
    data() {
        return {
        };
    },
    computed: {
        path() {
            return this.$route.path;
        },
        gemiusIdentifier() {
            return this.$store.getters.getGemiusIdentifier;
        }
    },
    mounted() {
        window.gemius_event(
            '_view_',
            this.gemiusIdentifier
        );          
    }
};
</script>